import React from "react";
import { Zap, Code, Megaphone, Camera } from "lucide-react";

const services = [
  {
    id: "complete-pack",
    icon: <Zap size={32} />,
    title: "Pack Complet",
    description:
      "All-in-one digital solution to launch, grow, and dominate your online presence.",
    color: "#9333ea",
    features: [
      "Professional Website Creation",
      "Sponsored Ads (Facebook & Instagram)",
      "Digital Marketing Strategy",
      "Professional Photo & Video Shooting",
      "Annual Support & Optimization",
    ],
    price: "1500 D / year",
    popular: true,
  },
  {
    id: "web",
    icon: <Code size={32} />,
    title: "Website Development",
    description: "Modern, fast and responsive websites for your business.",
    color: "#2563eb",
    features: ["React Website", "Responsive Design", "SEO Friendly"],
    price: "From 600 D",
  },
  {
    id: "marketing",
    icon: <Megaphone size={32} />,
    title: "Digital Marketing",
    description: "Grow your business with paid ads and smart strategies.",
    color: "#16a34a",
    features: ["Facebook Ads", "Instagram Ads", "Marketing Strategy"],
    price: "From 300 D",
  },
  {
    id: "media",
    icon: <Camera size={32} />,
    title: "Photo & Video",
    description: "Professional content to boost your brand image.",
    color: "#ea580c",
    features: ["Product Shooting", "Promo Videos", "Editing"],
    price: "From 250 D",
  },
];

function Services() {
  return (
    <section id="services" style={styles.section}>
      <h2 style={styles.title}>Our Services</h2>

      <div style={styles.grid}>
        {services.map((service) => (
          <div
            key={service.id}
            style={{
              ...styles.card,
              borderTop: `5px solid ${service.color}`,
              transform: service.popular ? "scale(1.03)" : "none",
            }}
          >
            {service.popular && (
              <div style={styles.badge}>
                <Zap size={14} style={{ marginRight: 5 }} />
                Best Value
              </div>
            )}

            <div style={{ color: service.color }}>{service.icon}</div>

            <h3 style={styles.cardTitle}>{service.title}</h3>
            <p style={styles.description}>{service.description}</p>

            <ul style={styles.list}>
              {service.features.map((feature, index) => (
                <li key={index}>✔ {feature}</li>
              ))}
            </ul>

            <div style={styles.price}>{service.price}</div>

            <button style={styles.button}>
              {service.popular ? "Choose This Pack" : "Get Started"}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Services;

const styles = {
  section: {
    padding: "80px 20px",
    backgroundColor: "#0f172a",
    color: "#fff",
  },
  title: {
    textAlign: "center",
    fontSize: "36px",
    marginBottom: "50px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: "30px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  card: {
    backgroundColor: "#020617",
    padding: "25px",
    borderRadius: "16px",
    position: "relative",
    transition: "0.3s ease",
  },
  badge: {
    position: "absolute",
    top: "-12px",
    right: "20px",
    backgroundColor: "#9333ea",
    padding: "6px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
  },
  cardTitle: {
    marginTop: "15px",
    fontSize: "22px",
  },
  description: {
    opacity: 0.8,
    margin: "10px 0",
  },
  list: {
    listStyle: "none",
    padding: 0,
    margin: "15px 0",
    lineHeight: "1.8",
  },
  price: {
    fontSize: "20px",
    fontWeight: "bold",
    marginBottom: "15px",
  },
  button: {
    width: "100%",
    padding: "12px",
    backgroundColor: "#9333ea",
    border: "none",
    borderRadius: "8px",
    color: "#fff",
    fontSize: "16px",
    cursor: "pointer",
  },
};